import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'scrollAnimation',
    label: 'Scroll Animation',
    type: types.BOOLEAN,
  },
  {
    key: 'left_col',
    label: 'Left Column',
    type: types.OBJECT,
    children: [
      {
        key: 'header',
        label: 'Header',
        type: types.TINYMCE,
      },
      {
        key: 'header_padding_bottom',
        label: 'Header Bottom Padding',
        type: types.TEXT,
      },
      {
        key: 'text',
        label: 'Text',
        type: types.TINYMCE,
      },
      {
        key: 'text_padding_top',
        label: 'Text Top Padding',
        type: types.TEXT,
      },
      {
        key: 'text_line_height',
        label: 'Text Line Height',
        type: types.TEXT,
      },
      {
        key: 'text_line_vertical_margin',
        label: 'Text Line Top/Bottom Margin',
        type: types.TEXT,
      },
      {
        key: 'desktop',
        label: 'Desktop',
        type: types.OBJECT,
        children: [
          {
            key: 'margin_top',
            label: 'Margin Top',
            type: types.TEXT,
          },
          {
            key: 'margin_left',
            label: 'Margin Left',
            type: types.TEXT,
          },
          {
            key: 'margin_right',
            label: 'Margin Right',
            type: types.TEXT,
          }
        ],
      },
      {
        key: 'tablet',
        label: 'Tablet',
        type: types.OBJECT,
        children: [
          {
            key: 'margin_top',
            label: 'Margin Top',
            type: types.TEXT,
          },
          {
            key: 'margin_left',
            label: 'Margin Left',
            type: types.TEXT,
          },
          {
            key: 'margin_right',
            label: 'Margin Right',
            type: types.TEXT,
          }
        ],
      },
      {
        key: 'mobile',
        label: 'Mobile',
        type: types.OBJECT,
        children: [
          {
            key: 'margin_top',
            label: 'Margin Top',
            type: types.TEXT,
          },
          {
            key: 'margin_left',
            label: 'Margin Left',
            type: types.TEXT,
          },
          {
            key: 'margin_right',
            label: 'Margin Right',
            type: types.TEXT,
          }
        ],
      },
      {
        key: 'enable_icons',
        label: 'Enable Icons',
        type: types.BOOLEAN,
      },
      {
        key: 'icons',
        label: 'Social Icons',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'icon',
            label: 'Icon',
            type: types.ICON,
          },
        ],
      },
    ],
  },
  {
    key: 'enable_right_col',
    label: 'Enable Right Column (Uncheck for single column layout)',
    type: types.BOOLEAN,
  },
  {
    key: 'right_col',
    label: 'Right Column',
    type: types.OBJECT,
    children: [
      {
        key: 'header',
        label: 'Header',
        type: types.TINYMCE,
      },
      {
        key: 'header_padding_bottom',
        label: 'Header Bottom Padding',
        type: types.TEXT,
      },
      {
        key: 'text',
        label: 'Text',
        type: types.TINYMCE,
      },
      {
        key: 'text_padding_top',
        label: 'Text Top Padding',
        type: types.TEXT,
      },
      {
        key: 'desktop',
        label: 'Desktop',
        type: types.OBJECT,
        children: [
          {
            key: 'show_empty_header',
            label: 'Show Header even if header text is empty',
            type: types.BOOLEAN,
          },
          {
            key: 'show_in_new_line',
            label: 'Show In New Line',
            type: types.BOOLEAN,
          },
          {
            key: 'margin_top',
            label: 'Margin Top',
            type: types.TEXT,
          },
          {
            key: 'margin_left',
            label: 'Margin Left',
            type: types.TEXT,
          },
          {
            key: 'margin_right',
            label: 'Margin Right',
            type: types.TEXT,
          }
        ],
      },
      {
        key: 'tablet',
        label: 'Tablet',
        type: types.OBJECT,
        children: [
          {
            key: 'show_empty_header',
            label: 'Show Header even if header text is empty',
            type: types.BOOLEAN,
          },
          {
            key: 'show_in_new_line',
            label: 'Show In New Line',
            type: types.BOOLEAN,
          },
          {
            key: 'margin_top',
            label: 'Margin Top',
            type: types.TEXT,
          },
          {
            key: 'margin_left',
            label: 'Margin Left',
            type: types.TEXT,
          },
          {
            key: 'margin_right',
            label: 'Margin Right',
            type: types.TEXT,
          }
        ],
      },
      {
        key: 'mobile',
        label: 'Mobile',
        type: types.OBJECT,
        children: [
          {
            key: 'show_empty_header',
            label: 'Show Header even if header text is empty',
            type: types.BOOLEAN,
          },
          {
            key: 'show_in_new_line',
            label: 'Show In New Line',
            type: types.BOOLEAN,
          },
          {
            key: 'margin_top',
            label: 'Margin Top',
            type: types.TEXT,
          },
          {
            key: 'margin_left',
            label: 'Margin Left',
            type: types.TEXT,
          },
          {
            key: 'margin_right',
            label: 'Margin Right',
            type: types.TEXT,
          }
        ],
      },
      {
        key: 'enable_icons',
        label: 'Enable Icons',
        type: types.BOOLEAN,
      },
      {
        key: 'icons',
        label: 'Social Icons',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'icon',
            label: 'Icon',
            type: types.ICON,
          },
        ],
      },
    ],
  },
];

const defaultProps = {
  scrollAnimation: true,
  left_col: {
    header: 'Sales Info',
    text: `
      <p>800.228.7702</p>
      <p>product@faradayfuture.com</p>
    `,
    enable_icons: false,
    icons: []
  },
  enable_right_col: true,
  right_col: {
    header: '',
    text: '',
    enable_icons: false,
    icons: []
  }
};

export default {
  title: 'Contact Block',
  id: 'ContactBlock',
  propsSchema,
  defaultProps
};
